import { Text, View } from '@react-pdf/renderer';
import logo from '@ui/assets/images/AMF/AMERIFLEX_RGB_PRIMARY_LOGO_AW.png';
import { EnvConfig } from '@ui/config/env';

import { usePDFContext } from '../PDFProvider';
import { EmployeeInformation } from './components/EmployeeInformation';
import { Header } from './components/Header';
import { Logo } from './components/Logo';
import { Page } from './components/Page';
import { CustomerAddress } from './components/QuoteDetails/CustomerAddress';
import { CustomerContact } from './components/QuoteDetails/CustomerContact';
import { QuoteDetails } from './components/QuoteDetails/QuoteDetails';
import { QuoteInformation } from './components/QuoteDetails/QuoteInformation';
import { QuoteId } from './components/QuoteId';
import { QuoteLineForPart, QuoteLineForServices } from './components/QuoteLine';
import { PartDescription } from './components/QuoteLine/PartDescription';
import { PartId } from './components/QuoteLine/PartId';
import { PartSpecs } from './components/QuoteLine/PartSpecs';
import { SiteInformation } from './components/SiteInformation';
import { Specs } from './components/Specs';
import { styles } from './components/styles';
import { TermsAndConditions } from './components/TermsAndConditions';

const AMF_SITE_INFORMATION = [
  '2390 Railroad St.',
  'Corona, CA 92880',
  'Phone (951) 737-5557',
];

export function AMFQuoteDocument() {
  const { quoteLines } = usePDFContext();

  return (
    <Page>
      <Header>
        <Logo source={logo} />

        <SiteInformation name="Ameriflex" items={AMF_SITE_INFORMATION} />

        <QuoteId ecommerceUri={EnvConfig.getKey('MW_COMPONENTS_URI')} />
      </Header>

      <QuoteDetails>
        <CustomerAddress />

        <CustomerContact />

        <QuoteInformation showFOB={true} />
      </QuoteDetails>

      {quoteLines.map((line) => {
        const { part, ...lineProps } = line;
        if (!part) {
          return <QuoteLineForServices {...line} showDescription />;
        }
        return (
          <QuoteLineForPart key={line.id} part={part} {...lineProps}>
            <PartId part={part} showCustomerPartId />

            <PartDescription description={part.description} />

            <PartSpecs specs={line.specs} />
          </QuoteLineForPart>
        );
      })}

      <Specs />

      <EmployeeInformation />

      <View style={styles.row}>
        <View style={[styles.fullRow]}>
          <Text style={[styles.bold, styles.textCenter]}>STANDARD FEES:</Text>
          <Text>MATERIAL CERTIFICATIONS $50 EA</Text>
          <Text>INSPECTION REPORT $50 EA</Text>
          <Text>FIRST ARTICLE INSPECTION REPORT $165 EA</Text>
          <Text>AS9102 FIRST ARTICLE INSPECTION REPORT $500 MIN</Text>
          <Text>MINIMUM ORDER $100</Text>
          <Text>ORDER CANCELLATION $100 MIN</Text>
        </View>
      </View>

      <View style={styles.row}>
        <View style={[styles.fullRow]}>
          <Text style={[styles.bold, styles.textCenter]}>
            ALL MANUFACTURING IS TO AMERIFLEX STANDARD VACUUM ELECTRONICS
            SPECIFICATIONS UNLESS OTHERWISE NOTED ON THIS QUOTE
          </Text>
          <Text style={[styles.bold, styles.textCenter]}>
            THANK YOU VERY MUCH FOR YOUR BUSINESS!
          </Text>
        </View>
      </View>

      <View style={styles.fullRow}>
        <TermsAndConditions style={[styles.textCenter]} />
      </View>
    </Page>
  );
}
